// Toast.js
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Function to show toast
export const showToast = (message, type = "info") => {
  switch (type) {
    case "success":
      toast.success(message);
      break;
    case "error":
      toast.error(message);
      break;
    case "warn":
      toast.warn(message);
      break;
    default:
      toast.info(message);
  }
};

// ToastContainer component (needs to be included in your App)
export const ToastProvider = () => {
  return <ToastContainer position="top-right" autoClose={3000} />;
};
